// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-a85398f2] .custom-fields {\n  width: 240px !important;\n  margin-top: 12px;\n}\n[data-v-a85398f2] .custom-fields .v-input__slot {\n  min-height: 0px !important;\n}\n[data-v-a85398f2] .custom-fields .v-text-field__details {\n  padding: 0px !important;\n}\n[data-v-a85398f2] .custom-fields input[type=number] {\n  text-align: left !important;\n}", ""]);
// Exports
module.exports = exports;
